import {
  Activity,
  BadgeDollarSign,
  Bell,
  CreditCard,
  Home,
  MessageCircle,
  MessageSquare,
  NotebookPen,
  Presentation,
  Settings2,
  Star,
  StickyNote,
  User,
} from "lucide-react";
import { ENABLE_FINANCIAL_AID_PROGRAM } from "./constants";

export const navbarNavigationLinks = [
  { title: "Courses", url: "/courses" },
  // { title: "Blogs", url: "/blogs" },
  // { title: "Leaderboard", url: "/leaderboard" },
  { title: "Testimonials", url: "/upwork-testimonials" },
  ENABLE_FINANCIAL_AID_PROGRAM
    ? { title: "Financial Aid", url: "/financial-aid-program" }
    : { title: "Affiliate Program", url: "/affiliate-program" },
].filter((item): item is { title: string; url: string } => Boolean(item));

export const sidebarNavigationLinks = [
  { title: "Courses", url: "/courses" },
  { title: "Blogs", url: "/blogs" },
  { title: "Reviews", url: "/course-reviews" },
  { title: "Testimonials", url: "/upwork-testimonials" },
  { title: "Leaderboard", url: "/leaderboard" },
  { title: "Affiliate Program", url: "/affiliate-program" },
  ENABLE_FINANCIAL_AID_PROGRAM && { title: "Financial Aid Program", url: "/financial-aid-program" },
].filter((item): item is { title: string; url: string } => Boolean(item));

export const footerGeneralNavigationLinks = [
  { title: "Courses", url: "/courses" },
  { title: "Blogs", url: "/blogs" },
  { title: "Reviews", url: "/course-reviews" },
  { title: "Upwork Testimonials", url: "/upwork-testimonials" },
  { title: "Leaderboard", url: "/leaderboard" },
];

export const footerProgramNavigationLinks = [
  { title: "Affiliate Program", url: "/affiliate-program" },
  ENABLE_FINANCIAL_AID_PROGRAM && { title: "Financial Aid Program", url: "/financial-aid-program" },
].filter((item): item is { title: string; url: string } => Boolean(item));

export const footerSupportNavigationLinks = [
  { title: "About", url: "/about" },
  { title: "Contact", url: "/contact" },
  { title: "Privacy Policy", url: "/privacy-policy" },
];

export const sidebarNavigationLinksForAdminDashboard = [
  {
    title: "Affiliation",
    url: "/admin/affiliation",
    icon: BadgeDollarSign,
    subItems: [],
  },
  {
    title: "Pages",
    url: "/admin/static-content",
    icon: StickyNote,
    subItems: [],
  },
  {
    title: "Notifications",
    url: "/admin/notifications",
    icon: Bell,
    subItems: [],
  },
  {
    title: "Feedbacks",
    url: "/admin/feedbacks",
    icon: MessageSquare,
    subItems: [],
  },
];

export const sidebarNavigationLinksForTeacherDashboard = [
  {
    title: "Dashboard",
    url: "/teacher/dashboard",
    icon: Home,
    subItems: [],
  },
  {
    title: "Courses",
    url: "/teacher/courses",
    icon: Presentation,
    subItems: [],
  },
  {
    title: "Blogs",
    url: "/teacher/blogs",
    icon: NotebookPen,
    subItems: [],
  },
  {
    title: "Testimonials",
    url: "/teacher/testimonials",
    icon: Star,
    subItems: [],
  },
  {
    title: "Payments",
    url: "/teacher/payments",
    icon: CreditCard,
    subItems: [],
  },
  {
    title: "Notifications",
    url: "/teacher/notifications",
    icon: Bell,
    subItems: [],
  },
];

export const sidebarNavigationLinksForStudentDashboard = [
  {
    title: "Dashboard",
    url: "/student/dashboard",
    icon: Home,
    subItems: [],
  },
  {
    title: "Account",
    url: "/student/account",
    icon: User,
    subItems: [],
  },
  {
    title: "Affiliation",
    url: "/student/affiliation",
    icon: BadgeDollarSign,
    subItems: [],
  },
  {
    title: "Notifications",
    url: "/student/notifications",
    icon: Bell,
    subItems: [],
  },
  {
    title: "Your Activity",
    url: "/student/activity",
    icon: Activity,
    subItems: [
      {
        title: "Comments",
        url: "/student/activity/comments",
        icon: MessageCircle,
      },
      {
        title: "Feedbacks",
        url: "/student/activity/feedbacks",
        icon: MessageSquare,
      },
    ],
  },
  {
    title: "Settings",
    url: "/student/settings",
    icon: Settings2,
    subItems: [],
  },
];

// Recycled

// {
//   title: "Dashboard",
//   url: "/teacher/dashboard",
//   icon: Home,
//   // isActive: true,
//   subItems: [],
// },

// {
//   title: "Profile",
//   url: "/student/profile",
//   icon: CircleUser,
//   subItems: [],
// },
